{{ 'Project::ProjectPublishedSuccessfully' | abpLocalization }}
<i>{{ notification.project }}</i>
(<i>v{{ notification.version }}</i
>)
